import { Skeleton } from '@/presentation/components/ui/skeleton'

export default function DriverStatsColumnSkeleton() {
  return (
    <div className="flex items-center justify-end">
      <Skeleton className="h-4 w-16" />
    </div>
  )
}
